// test294
(294 && 0);
